import React, { useState, useEffect } from 'react';
import { NavLink, Redirect, Link } from "react-router-dom";
import AxiosServices from '../../services/AxiosServices';
import Singleton from '../../core/singleton';
import events from '../../core/events';
import Modal from '../../ui/Modal';
import Logo from '../../ui/img/logo.svg';
import Forms from './forms';

export const Header = props => {
    const { eventEmitter, getTradByKey, setAuthCredencials, clearAuth, authCredencials } = Singleton.getInstance();
    /** store the required elements */
    const [registrationNumber, setRegistrationNumber] = useState(authCredencials.registrationNumber());
    const [trip, setTrip] = useState({
        iataTo: authCredencials.iataTo(),
        iataFrom: authCredencials.iataFrom(),
    });
    const [resetState, setResetState] = useState(null);
    const { pathname } = props.location;
    const tripIsSet = (trip && (trip.iataFrom !== null) && (trip.iataTo !== null));
    const showNav = (tripIsSet && (registrationNumber !== null));
    const showHomeBtn = (pathname !== "/" && pathname !== "/home");
    const userIsUnknown = (registrationNumber === null);
    /** just reset the state with the passed args */
    const onUserRegistration = number => {
        setAuthCredencials({ 'registrationNumber': number });
        setRegistrationNumber(number);
    };
    /** when we finaly got an iatoFrom and a iataTo,we can perform an ajax request  */
    const onUserRouteSelect = trip => {
        AxiosServices.route({ "from": trip.iataFrom, "to": trip.iataTo }).then(() => {
            setAuthCredencials({ 'iataTo': trip.iataTo, 'iataFrom': trip.iataFrom });
            setTrip(trip);
        })
    };
    /** when the user try to logout we got to perform an ajax request  */
    const onUserLogout = () => {
        let reset = () => {
            clearAuth();
            setRegistrationNumber(null);
            setTrip(null);
            document.location = document.location;
        }
        AxiosServices.logout()
            .then(() => reset())
            .catch(error => (error.response.status === 401) ? reset() : null)
    }
    /** when the user click on the logout btn  */
    const logout = () => {
        document.querySelector('.logout-btn').classList.add("pointer-events-none");
        eventEmitter.emit(events.ON_USER_LOGOUT);
    };
    /** set some listeners on component Did Mount event  */
    useEffect(() => {
        eventEmitter.on(events.ON_USER_REGISTRATION, onUserRegistration);
        eventEmitter.on(events.ON_USER_ROUTE_SELECT, onUserRouteSelect);
        eventEmitter.on(events.ON_USER_LOGOUT, onUserLogout);
    }, []);
    /** if the user is knwown we can show the navbar    */
    const Nav = () => (userIsUnknown === false) ? <nav className="my-2 my-md-0 ">
        {
            (showHomeBtn) &&
            <NavLink to="/home" className="p-2 btn" href="#">
                <i className="fas fa-home"></i> HOME&nbsp;<sup><span className="badge badge-primary">9</span></sup>
                <span className="sr-only">unread messages</span>
            </NavLink>
        }
        {
            (showNav) &&
            <button onClick={() => setResetState("ResetTrip")} className="pt-0 pb-0 btn tripSelectorBtn" href="#">
                <i className="fas fa-plane-departure"></i> {trip.iataFrom} <i className="fas fa-angle-right"></i> {trip.iataTo} <i className="fas fa-plane-arrival"></i>
            </button>
        }
        <button onClick={() => setResetState("ResetRegistrationNumber")} className="pt-0 pb-0 btn registrationNumber" href="#"><i className="fas fa-user"></i> {registrationNumber.toUpperCase()}</button>
        {
            (!userIsUnknown) &&
            <button onClick={() => logout()} className="pt-0 pb-0 btn logout-btn " ><i title="logout" className="fas fa-sign-out-alt"></i> LOG OUT</button>
        }

    </nav> : null;
    /** a modal with a form inside   */
    const PopUp = () => (resetState !== null) ? <Modal onClose={() => setResetState(null)}>
        {
            Forms[resetState]({
                trip: trip,
                registrationNumber: registrationNumber,
                close: () => setResetState(null)
            })
        }
    </Modal> : null
    return <header className="sticky-top crewApp-header">
        {
            (userIsUnknown === true) &&
            <Redirect to='/' />
        }
        <PopUp />
        <div className={`d-flex flex-column flex-md-row align-items-center pl-3 pt-3 pb-3 mb-3 bg-white border-bottom shadow-sm`}>
            <Link to={(userIsUnknown && !tripIsSet) ? '/' : 'home'} className={`d-block my-0 ${(userIsUnknown === false) ? 'mr-md-auto' : 'm-auto'}`} href="#">
                <h5 className="m-0">
                    <img className="cursor-pointer" width="150" src={Logo} alt={getTradByKey('ugo_crew')} />
                </h5>
            </Link>
            <Nav />
        </div>
    </header>
}